module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("WHEN THE")]), _vm._v(" truck finally died, it went out in style. Not one of those pathetic whining, spluttering deaths. It exploded, with sparks and everything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James had used good sense—for once in his life—to grab his backpack from the passenger seat before he sprang from the vehicle and dashed away. Smoke poured out from under the hood.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He called the number his dad had programmed into his phone the day he got the old blue Chevy Silverado as a sixteenth birthday present. The truck had been given to his dad as a white elephant gift, a running joke among his buddies that Mark would never get the damn thing running.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had run beautifully for almost two years.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Forest Heights Motors.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hi, yeah, this is James Henderson. My car just exploded.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The person who had picked up the phone made a sort of aborted choking noise. “Okay. Where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mullender, just past the old hardware place.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All right. The tow truck will be there in twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That seemed reasonable. While he waited, James stood on the opposite side of the road from the smoking truck, turning his phone over and over in his hands. He knew he should call someone for help, but the people he loved most in the world were prone to panicking and dramatic scenes, and that was best left for when they were somewhere more private.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Around fifteen minutes later, the tow truck pulled up, and one seriously hot guy hopped out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because yes, thank you universe, that was just what James needed right now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hi. I’m Dylan,” he said by way of introduction. “Looks like you need a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Har-har,” James said drily, narrowing his eyes. “It was on fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I doubt that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It was,” James insisted. “There was smoke and everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“When it comes to cars, smoke doesn’t necessarily mean fire.” The guy rolled his impressively broad shoulders. He was wearing a black Forest Heights Motors T-shirt, his arms covered in streaks of grime and oil. His jeans were ripped at the knee.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James was staring.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Holy shit.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Anyway, I’ll get started,” he said, and James nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It wasn’t like James knew much about trucks, or engines, or how they got towed from one place to another. He was, however, quite content to sit back and watch as Dylan got the still-smoking Chevy onto the back of the tow truck. It involved hooks and winches and stuff that James was pretty sure could get him killed if he interfered. Dylan seemed to know what he was doing, so James didn’t offer to help.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dylan was tall, with olive skin and rich brown eyes that in James’s weakest moments he would describe as dreamy. He had a five-o’clock shadow and thick, almost black hair that was neatly styled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Dylan bent over to attach the pulley to the front of the truck, James got a great view of his ass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Thank you, Baby Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hop in,” Dylan said as he was cranking the front wheels of the truck up. “I can give you a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks,” James said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The radio was still playing in the tow truck—a local rock station—with the volume turned down low. James decided he wasn’t going to tell his dad what had happened until he knew the fate of the truck. Though he wasn’t holding out much hope. He was only allowed to drive it because they couldn’t afford to buy anything fancier and James was absolutely not going to take the bus for his senior year of high school. It looked like he was back to walking or trying to convince one of his friends to give him a ride, unless he could figure out the money for repairs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You okay?” Dylan said as he slid into the driver’s side of the tow truck.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. Bit bummed, but I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I had a quick look. I think it’s a cracked cylinder head, which is fixable. I need to let it cool down to have a closer look at it, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah?” James allowed himself a moment of hope.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dylan shrugged. “I think so. I’m not qualified yet, though, so….” He shrugged again. “Wait and see what Joe says in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Joe was one of James’s dad’s poker buddies, and the reason James had the truck in the first place. If Joe couldn’t fix the thing, then it really was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("An easy sort of silence settled between them as Dylan drove back to the garage, the radio still playing low. James turned his phone over and over in his hands. It was a nervous habit, one he barely noticed, let alone tried to break.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You need to call anyone?” Dylan asked as they pulled into the garage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nah,” James said. “My dad won’t be home from work for a few hours yet, and my sister is at a study group.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Need a ride home?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James turned his head. Dylan was blushing a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dylan nodded. “I don’t mind. I was just leaving when you called.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry for keeping you late.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay. I’ll leave a message to make sure Joe looks at your truck tomorrow, and then I can give you a call when we know what’s wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was weird—stilted and awkward. James was practically an expert at stilted and awkward. He was the reigning champion of doing stupid, awkward things, and apparently that got worse when he was presented with a really attractive boy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dylan jumped out of the cab and went about setting James’s truck free on the forecourt, presumably to let it cool down. The garage itself was quiet, only one other guy wandering around inside. A moment later, James jumped when Dylan shoved a clipboard through the open window.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can you fill this in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James grunted. By the time he’d figured out his words, Dylan was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Name, phone number, vehicle type, registration number.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He could do this.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he flipped the page over, there was another slip of paper, a Forest Heights Motors compliments slip. There was a note on it, handwritten.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Phone number")]), _vm._v(", it read. Then, in brackets, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("For Dylan")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Okay.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James copied down his phone number again. Then put a smiley face next to it. Then hated himself.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“JAMES!”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James rolled over in bed and buried his face under his pillow. His warm, soft, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("mmmm")]), _vm._v(", pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("James")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The noise was now a roar. It turned into a rhythmical, loud "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("thunking")]), _vm._v(", and then his bedroom door was thrown open, and his dad loomed in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” James moaned into his pillow. “Nooo.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You are already late for school. If you can get yourself ready in the next thirteen minutes, I can drop you off.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have a truck,” James mumbled into his pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, you don’t. It’s in the garage.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Language. Move, James. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Now")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His door slammed shut again. For a moment, James held still, and then he thrashed all the covers off himself. Stupid school. Stupid truck.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He rolled off the bed and stumbled blindly into the bathroom he shared with Frankie. His sister was already in it, brushing her teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Get the fuck out, James,” she said after spitting out her mouthful of toothpaste.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can’t,” he grumbled. “Late.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Jesus,” she muttered when he turned his back to her and peed into the toilet. “You’re so fucking disgusting.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“At least I didn’t do it in the shower,” he called after her as she stomped out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He showered in record time, using Frankie’s shower gel partly to piss her off and partly because he felt like smelling of lotus flower and jasmine today. He brushed his teeth while he was getting dressed and rinsed and spat just as his dad called that they were “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("leaving, now, James,")]), _vm._v("” and he ran downstairs to grab his backpack from where it lived next to the front door. He’d gotten into the habit of packing it with his homework as soon as he was done in the evenings. At times like these, he blessed his self of ten hours ago.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Frankie was in the front seat, because of course she was, even though she knew James got carsick when he wasn’t driving. It only took fifteen minutes to drive over to the school, time James spent with his eyes closed, taking deep breaths. Then his dad was pulling into one of the spaces reserved for teachers and mumbling at them to behave and have a good day.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James’s stomach was growling as he stalked away from his father as soon as he could. He kept a box of protein bars in his locker for mornings like this… mornings when he didn’t have the energy to morning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Frankie peeled off without saying goodbye, already heading to her locker a hallway over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bye!” James yelled at her. She raised her middle finger in return, not even looking back over her shoulder to see if James saw it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In some ways, James and Frankie were still ridiculously similar. They had been close growing up, a symptom of being twins with only a father and spending most of their time together. They had played on the same baseball team until fifth grade, and they had always shared books and movies.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Puberty had been weird. Some days, James thought Frankie looked just like their mom. She had the same hair color, the rich strawberry blonde that fell in thick waves past her shoulders. That was the only thing Frankie inherited from their mother, apart from their golden brown eyes. Those identical sets of eyes marked them as siblings from the moment they were born.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did you come in with Dr. Henderson today?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James barely flinched at the loud voice over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dude, don’t call my dad Dr. Henderson. It’s creepy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s better than me calling him Mark. He gave me detention the last time I forgot and called him Mark in class.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ugh.” James scowled as he conceded. “The truck broke down yesterday. It’s in the garage.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dude. That sucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know.” James exchanged a few books, then grabbed his power bar, unwrapped it, and took a huge bite all in one motion. He fell into step with Anthony, who had most of the same classes as James.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James shared genetics with Frankie, but Anthony was his brother. No one argued that. They’d found each other at the age when he and Frankie were discovering there were other children in the world to be friends with, and he and Anthony had been joined at the hip ever since. James never thought of it as a bad thing. Frankie had her little cluster of girlfriends, and he had Anthony. It was more than fair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There were four high schools available to students who lived in Forest Heights County, California, located just south of Sequoia National Forest. Two of them were out of the question, as far as their father was concerned—not up to the standards of teaching he expected for his children. The third would mean almost an hour’s commute in each direction every day. James wasn’t entirely convinced his dad hadn’t been setting up this situation since he and Frankie were kids, but it was pretty clear which school they were going to go to.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Luckily, Forest Heights High had a large enough student population to warrant two chemistry teachers, and it had been agreed when James and Frankie enrolled that they would never be taught by their father. That agreement had been broken only once, when the other chemistry teacher got the flu and their dad covered James’s class for a week, but they all had a family agreement to never speak of it again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey,” James said, the thought coming to him as he pulled his notepad and last night’s homework from his bag. “So you know Joe’s? The garage.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure,” Anthony said. He shrugged. “Old Joe fixed up my mom’s car when she blew a gasket last winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James nodded slowly. “Do you know Dylan?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dylan?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He was the one to come pick me up in the truck. He runs the tow, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Anthony shook his head. “Doesn’t sound familiar. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No reason.” James fought to hide his blush.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Being friends with someone for a long time made things like blushing almost redundant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you, like, attracted to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James had come out to Anthony a few months ago. It had been a whispered secret, something James was barely ready to admit to himself, let alone anyone else. Anthony had been okay with it, but weird around James until James made it very painfully clear that he wasn’t attracted to Anthony. Like, at all. Anthony was his brother, and ew, no.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s all right,” he said in answer to Anthony’s question. “He asked for my number.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But he works at Joe’s? So he’s not in high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I guess so. Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Your dad would flip out.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James huffed a laugh. “I have no intention of letting my dad know.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dude,” Anthony said, and conveyed more emotion in that one word than James would have thought possible. Their economics teacher walked into class looking incredibly stressed just as the bell rang.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Pop quiz,” she announced, and James joined in the groaning across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James was the most middle-of-the-road student possible. He got solid Bs in nearly all his subjects, with the occasional A or C thrown in to make things interesting. He’d long since accepted that he and Frankie would likely end up going to different colleges, and he was still trying to figure out how he felt about that. They’d only recently come through a period of hating each other with a burning passion. Now they were starting to be good friends again. It almost seemed a shame to split up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Frankie was creative. She wrote and drew and danced and sang, played a handful of instruments, and was learning how to throw clay. She painted stuff, and while James didn’t know what the fuck the paintings were supposed to be, he found them interesting. Frankie created shit, and James had no doubt she would go to a college where they could nurture that far better than FHH had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James had applied to the same colleges that Anthony had, and left the rest to fate. If the thought of living away from Frankie was weird, the thought of being split up from Anthony was unbearable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He mooched his way through the school day, making notes, offering an opinion when it was solicited, answering questions if asked. Maybe because it was January and he’d graduate soon, but days seemed to fly by without making much of an impact.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("After school, he called Joe’s and got a half-grunted explanation that yes, his truck was fixable, and no, it wasn’t ready yet. It was Thursday, which meant Frankie was at some kind of rehearsal, Anthony had baseball practice, and his dad wouldn’t be done with grading for a while yet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("With nothing better to do and no way of getting home apart from walking—and no, to that—James set himself up in the library to get his homework done ahead of schedule. He was turning into such a nerd.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ON FRIDAY")]), _vm._v(" night, James had nowhere to go. Anthony was out with his mom. Frankie had a “study date” with her “lab partner,” and James didn’t need to read her diary to know that whatever she was doing had no academic value whatsoever. He almost wished he was working so he could get out of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James dramatically draped himself over the single armchair in the family room, letting his head tip back over one arm and his legs dangle over the other.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m going out,” his dad announced, lightly jogging down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Traitor,” James muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His dad looked nice too—not super dressed up, but not like a middle-aged high school chemistry teacher either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t tell me you have a date too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” he laughed. “I’m just meeting some buddies for a beer and a game of pool. I’m sick of grading papers.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sick of being the only one at home on a Friday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Here’s twenty.” His dad dug a couple bills out of his wallet. “Let pizza make up for my terrible parenting.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll survive,” James said brightly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He didn’t really mind his dad going out. It had been years since he’d had much of a social life—being the ever-responsible Dr. Mark Henderson, chemistry teacher and single parent to teenage twins, hadn’t left a lot of space in his life for being a social butterfly. James knew there would be two big holes in his dad’s life when he and Frankie went to college. It was probably good to start working through that separation anxiety early.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I won’t be late. Don’t kill anything or burn the house down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And James?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James gave him a sweet smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know how many beers are in the fridge. Don’t try anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fine,” he sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He watched his dad head to his car and drive down the street, and then he flopped back over the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It wasn’t like James didn’t have friends other than Anthony and Frankie. He did. He got invited to parties. He liked hanging out with the guys from the baseball team. If he called any one of them, they’d probably come over and share a pizza. He wasn’t in the mood for company, though.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James pulled his phone out of his pocket and dialed the local pizza place that was about a hundred times better than any chain restaurant could even hope to be.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, it’s James,” he said when Jeff answered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hi, James. Large pepperoni?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I hate my life,” James muttered in response.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Forty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("James hung up and viciously fought the desire to pout.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0